export const blogs = {
  blogsFeedCreateInputPlaceholder: '게시물 작성...',
  blogsFeedSearchInputPlaceholder: '검색',
  blogsFeedPostOwnerCurtainEditTitle: '게시물 편집',
  blogsFeedPostOwnerCurtainDeleteTitle: '게시물 삭제',
  blogsFeedEditedPostSavedAlertText: '게시물이 저장되었습니다!',
  blogsFeedEditedPostDeletedAlertText: '게시물이 삭제되었습니다!',
  blogsFeedShareCurtainOptionTitle: '링크 복사',
  blogsFeedPostLinkCopiedAlertText: '링크가 복사되었습니다!',
  blogsFeedOthersPostCurtainOptionCopyTitle: '링크 복사',
  blogsFeedOthersPosLinkCopiedAlertText: '링크가 복사되었습니다!',
  blogsFeedOthersPostCurtainOptionFlagTitle: '콘텐츠 신고',
  blogsFeedOtherPostOwnersCurtainDeleteTitle: '게시물 삭제',
  blogsFeedPostDeletePopupTitle: '삭제',
  blogsFeedPostDeletePopupText: '이 게시물을 삭제하시겠습니까?',
  blogsFeedPostDeletePopupCancelButtonTitle: '취소',
  blogsFeedPostDeletePopupConfirmButtonTitle: '확인',
  blogsFeedPostDeeletedAlertText: '게시물이 삭제되었습니다!',
  blogsPostDetailsHeaderTitle: '게시물',
  postFeedPostLikesText: '좋아요',
  postFeedPostCommentsText: '댓글',
  postFeedPostNoLikesText: '아직 좋아요가 없습니다',
  postFeedPostLeaveFirstLikeText: '첫 번째 좋아요를 남겨보세요',
  blogsFeedPostDetailsNoCommentsText: '아직 댓글이 없습니다',
  blogsFeedPostDetailsFirstCommentText: '첫 번째 댓글을 남겨보세요',
  blogsFeedPostDetailsShareOptionTitle: '링크 복사',
  blogsFeedPostDetailsSharePostCopiedAlertText: '링크가 복사되었습니다!',
  blogsFeedPostDetailsUsersCurtainCopyOptionTitle: '링크 복사',
  blogsFeedPostDetailsCopiedAlertText: '링크가 복사되었습니다!',
  blogsFeedPostDetailsUsersCurtainFlagOptionTitle: '콘텐츠 신고',
  blogsPostDetailsFlagCurtainOptionSpamTitle: '신고',
  blogsPostDetailsReportedCurtainText: '콘텐츠가 신고되었습니다',
  blogsPostDetailsCommentOwnerCurtainEditOptionTitle: '댓글 편집',
  blogsPostDetailsCommentOwnerCurtainDeleteOptionTitle: '댓글 삭제',
  blogsPostDetailsEditedCommentSavedAlertText: '댓글이 저장되었습니다!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: '댓글 삭제',
  postDetailsOtherUsersCommentDeletadAlertText: '댓글이 삭제되었습니다!',
  postDetailsDeleteCommentPopupTitle: '삭제',
  postDetailsDeleteCommentPopupText: '이 댓글을 삭제하시겠습니까?',
  postDetailsDeleteCommentPopupCancelButtonTitle: '취소',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: '확인',
  postDetailsCommDeletedAlertText: '댓글이 삭제되었습니다!',
  postDetailsCommentUserCurtainOptionTitle: '콘텐츠 신고',
  blogsCreatePostCurtainTitle: '새 게시물',
  blogsCreatePostCurtainBodyPlaceholder: '여기에 텍스트를 입력하세요...',
  blogsCreatePostPublishButtonTitle: '게시',
  blogsCreatePostUploadSlallerImageAlertText: '한 번에 최대 {size} MB만 업로드할 수 있습니다',
  blogsPostSavedAlertText: '게시물이 저장되었습니다!',
  blogsCreatePostAddLocationCurtainTitle: '장소',
  blogsCreatePostAddLocationCurtainInputPlaceholder: '장소 이름',
  blogsCreatePostEditLocationCurtainText: '장소 편집',
  blogsDeleteLocation: '장소 삭제',
  blogsDiscardPostPopupTitle: '드래프트',
  blogsDiscardPostPopupText: '이 드래프트를 삭제하시겠습니까?',
  blogsDiscardPostPopupCancelButtonTitle: '취소',
  blogsDiscardPostPopupCofirmButtonTitle: '확인',
  blogsNewPostCreatePollTitle: '투표 만들기',
  blogsNewPostCreatePollTitleInputPlaceholder: '제목',
  blogsNewPostCreatePollOptionInputPlaceholder: '옵션',
  blogsNewPostCreatePollAddButtonTitle: '옵션 추가',
  blogsNewPostCreatePollCreateButtonTitle: '만들기',
  blogsCreatePostPollTitleBlankAlertText: '제목은 비워둘 수 없습니다!',
  blogsCreatePostPollOptionBlankAlertText: '옵션은 비워둘 수 없습니다!',
  blogsCreatePostPollLongTitleAlertText: '제목은 최대 {length}자여야 합니다',
  blogsCreatePostPollLongOptionAlertText: '옵션은 최대 {length}자여야 합니다',
  blogsCreatePostPollEditOptionTitle: '투표 편집',
  blogsCreatePostPollRemoveOptionTitle: '투표 제거',
  blogsPostPollInfoVotesText: '투표',
  blogsPostPollInfoEditVoteText: '투표 편집',
  blogsPostPollFinishPollText: '투표 종료',
  blogsPostPollFinishedPollText: '종료됨',
  blogsPostPollInProgresslText: '진행 중',
  blogsFinishPollCurtainTitle: '투표 종료',
  blogsFinishPollCurtainText: '투표 종료 후에는 사용자가 투표할 수 없습니다.',
  blogsFinishPollCurtainCancelButtonTitle: '취소',
  blogsFinishPollCurtainConfirmlButtonTitle: '확인',
  blogsPollInfoPollVotesCurtainTitle: '투표 결과',
  blogsEditPostCurtainTitle: '게시물 편집',
  blogsEditPostCurtainNoTextBodyPlaceholder: '여기에 텍스트를 입력하세요...',
  blogsEditPostCurtainSaveButtonTitle: '저장',
  blogsEditPostSavedAlertText: '게시물이 저장되었습니다!',
  blogsError: '문제가 발생했습니다!',
  blogsAt: '에서',
  blogsSeeMore: '더 보기...',
  blogsMaxAttachments: '첨부 파일은 최대 {length}개까지 가능합니다',
  blogsReply: '댓글',
  blogsAddCover: '표지 이미지 추가'
}
